module.exports = __webpack_public_path__ + "img/DOD-5000.4195b9de.png";